module.exports = __webpack_public_path__ + "static/img/4.1bb69eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-de-mascotas/4.png
// module id = oonE
// module chunks = 0